<ng-container *ngIf="control">
  <mat-form-field [floatLabel]="floatLabel()">
    <mat-label>{{ label() }}</mat-label>
    <mat-select
      [placeholder]="placeholder()"
      [multiple]="multiple()"
      [formControl]="control"
      disableOptionCentering
    >
    @if (firstOption()) {
      <mat-option
        [value]="firstOption()?.id"
        [disabled]="disabledOptions()"
        >{{ firstOption()?.name }}</mat-option
      >
    }
    @if (options()) {
      <mat-option
        [value]="option.id"
        [disabled]="disabledOptions()"
        *ngFor="let option of options()"
        >{{ option.name }}</mat-option
      >
    }
    @if (manualOptions()) {
      <mat-option
        [value]="lookup.value"
        [disabled]="disabledOptions()"
        *ngFor="let lookup of manualOptions()"
        >{{ lookup.name }}</mat-option
      >
    }
    </mat-select>
    <mat-error *ngIf="control?.hasError('required')">Required</mat-error>
    <mat-error *ngIf="control?.hasError('message')" [id]="''">{{ control.getError('message') }}</mat-error>
  </mat-form-field>
</ng-container>
